'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Box = require('../../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../../common/components/Typography.js');
var SessionContext = require('../../../../../../../../common/providers/SessionContext.js');
var Currency = require('../../../../../../../../common/components/Currency.js');
var nthBitHeader = require('@narvar/nth-bit-header');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemCardItemDetails = _ref => {
  let {
    item
  } = _ref;
  const {
    claimsItemAttrLabelColor,
    claimsItemAttrLabelQuantityClaimed,
    claimsItemAttrLabelSize,
    claimsItemAttrLabelSku
  } = nthHookTranslations.useTranslations();
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1
  }, item.name && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, null, item.name), item.quantity && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelQuantityClaimed ?? ''}: ${item.quantity}`), item.sku && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelSku ?? ''}: ${item.sku}`), item.color && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelColor ?? ''}: ${item.color}`), item.size && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelSize ?? ''}: ${item.size}`), item.price && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    value: item.price,
    locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
    currency: 'USD'
  })));
};
var ItemCardItemDetails$1 = nthHookTranslations.withTranslationsProvider(ItemCardItemDetails, {
  translationKeys: ['claimsItemAttrLabelColor', 'claimsItemAttrLabelQuantityClaimed', 'claimsItemAttrLabelSize', 'claimsItemAttrLabelSku']
});

exports["default"] = ItemCardItemDetails$1;
